import { Keplr } from './keplr.js';
import KeplrWalletConnect from './keplrWalletConnect.js';

const getKeplerConnector = ({ evmNetworks, }) => {
    const keplr = new Keplr({ evmNetworks });
    if (keplr.isInstalledOnBrowser()) {
        return keplr;
    }
    else {
        return new KeplrWalletConnect({ evmNetworks });
    }
};

export { getKeplerConnector };
